module.exports = __webpack_public_path__ + "assets/202509252035/img/sleep.26420291.jpg";